import {
  GET_LIST_KIEMKHO,
  GET_LIST_KIEMKHO_SUCCESS,
  GET_LIST_KIEMKHO_FAILURE,
} from "../../actions/KiemKho/actionTypes";

const initialState = {
  List: [],
  TTotalQuantity: 0,
};
const getListKiemKho = (state, action) => ({
  ...state,
  getListKiemKhoLoading: true,
});

const getListKiemKhoSuccess = (state, action) => {
  return {
    ...state,
    List: action.payload.List,
    TTotalQuantity: action.payload.TTotalQuantity,
    getListKiemKhoLoading: false,
  };
};

const getListKiemKhoFailed = (state, action) => ({
  ...state,
  getListKiemKhoLoading: false,
  List: [],
});
export const listKiemKhoReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_KIEMKHO:
      return getListKiemKho(state, action);
    case GET_LIST_KIEMKHO_SUCCESS:
      // alert("tuty");
      return getListKiemKhoSuccess(state, action);
    case GET_LIST_KIEMKHO_FAILURE:
      //alert('false')
      return getListKiemKhoFailed(state, action);
    default:
      return state;
  }
};

export default listKiemKhoReducer;
